import {gql} from "@apollo/client";

import {PlanInfo} from "@/lib/types/accounts.ts";

interface CheckLimitV1 {
  is_exhausted: boolean;
  limit_name: string;
  pending_purchase_request_at?: string;
  current_plan?: PlanInfo;
  next_plan?: PlanInfo;
  current_limit: number;
}

export interface CheckLimitV1Response {
  checkSubscriptionV1Limit: CheckLimitV1;
}

export const GQL_CHECK_LIMIT_V1 = gql`
  query CheckSubscriptionLimitV1($service: MonitoringServiceType!, $requested: Int) {
    checkSubscriptionV1Limit(service: $service, requested: $requested) {
      is_exhausted
      current_limit
      limit_name
      pending_purchase_request_at
      current_plan {
        ...PlanInfoFields
      }
      next_plan {
        ...PlanInfoFields
      }
    }
  }
`;
